import { 
  GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS,
  GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_ERROR, 
  GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_ERROR, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, 
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR,
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_calls_dashboard_states: null,
  loading: false,
  user_column_preference_calls_dashboard_campaigns: null,
}

const UserCallsDashboardColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_calls_dashboard_states: action.payload,
        loading: false
      }

    case GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_calls_dashboard_states: action.payload,
        loading: false
      }

    case UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
      // lead source settings
    case GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS:
        return {
          ...state,
          loading: true
        }
  
    case GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS:
        return {
          ...state,
          user_column_preference_calls_dashboard_campaigns: action.payload,
          loading: false
        }
  
    case GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false
        }
  
    case UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS:
        return {
          ...state,
          loading: true
        }
  
    case UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS:
        return {
          ...state,
          user_column_preference_calls_dashboard_campaigns: action.payload,
          loading: false
        }
  
    case UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false
        }
    default:
      return state
  }
}

export default UserCallsDashboardColumnPreference;
